module.exports = __webpack_public_path__ + "static/media/studio-etc5.4513bd86.png";